export default __webpack_public_path__ + "static/media/check_box-24px.0ae15f48.svg";